import React from 'react';
import cn from 'clsx';

import { AngleRightRegularIcon } from '../../../../shared/icons/icons';
import Link from '../../../link/link';
import Typography from '../../../typography/typography';

import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import styles from './breadcrumbs.scss';

interface BreadcrumbsProps {
  className?: string;
  crumbs: {
    name: string;
    url?: string;
  }[];
}

function Breadcrumbs(props: BreadcrumbsProps) {
  const { className, crumbs } = props;

  return isArrayWithLength(crumbs) ? (
    <div className={cn(styles['container'], `${className || ''} breadcrumbs`)}>
      <ol className={cn(styles['crumbs'], 'breadcrumbs__list')}>
        {crumbs.map((crumb, idx) => (
          <li
            className={cn(styles['crumb'], 'breadcrumbs__list-item')}
            key={`bc-${idx}`}
          >
            {crumb.url ? (
              <Link
                className={cn(
                  styles['crumb-link'],
                  'dt-link breadcrumbs__list-item-link'
                )}
                to={crumb.url}
              >
                <Typography size="extraSmall">{crumb.name}</Typography>
                <AngleRightRegularIcon
                  className={cn(
                    styles['crumb-arrow'],
                    'breadcrumbs__crumb-arrow'
                  )}
                />
              </Link>
            ) : (
              <div className={styles['crumb-text']}>
                <Typography size="extraSmall">{crumb.name}</Typography>
              </div>
            )}
          </li>
        ))}
      </ol>
    </div>
  ) : null;
}

export default Breadcrumbs;
